import API from "../api";
import commonAction from "./commonAction";

const api = new API();

export const updateTableOfChanging = id => {
  const body = {
    id
  };
  return dispatch =>
    commonAction(
      dispatch,
      "post",
      "/storyboard",
      body,
      "LOAD_CHANGING",
      "data"
    );
};



// WEBPACK FOOTER //
// ./actions/updateTableOfChanging.js